import { ReactNode } from "react";
import { useRecoilState } from "recoil";
import { MainNavBtns, Stepper } from "src/components";
import {
  HasProposal,
  HasYearBookingContent,
  NoBookingContent,
  NoYearGroupContent,
} from "src/components/YearBooking";
import { useUserStepStatusYear } from "src/hooks";
import { recoilStates } from "src/recoil/recoilStates";
import { colors } from "src/styles/theme";
import { MainNavChildObjectType, NavMenuNames, userStepStatusYear } from "src/types";
import styled, { css } from "styled-components";

import { FaHandshake } from "react-icons/fa";
import { FaCoins } from "react-icons/fa";

import step1 from "../assets/images/step1.svg";
import step2 from "../assets/images/step2.svg";
import step3 from "../assets/images/step3.svg";
import step4 from "../assets/images/step4.svg";
import step3of from "../assets/images/step3-off.svg";
import step4of from "../assets/images/step4-off.svg";

// import step1of from "../assets/images/step1-off.svg";
import step2of from "../assets/images/step2-off.svg";
// import step5 from "../assets/images/step5.svg";
// import step5of from "../assets/images/step5-off.svg";
import step6 from "../assets/images/step6.svg";
import step6of from "../assets/images/step6-off.svg";
import step7 from "../assets/images/step7.svg";
import step7of from "../assets/images/step7-off.svg";
import step8 from "../assets/images/step8.svg";
import step8of from "../assets/images/step8-off.svg";

import { setTime23_59_59 } from "src/utils";

import faq from "../assets/images/help.svg";
import list from "../assets/images/list_alt.svg";
import memberIcon from "../assets/images/member_box.svg";
import groupIcon from "../assets/images/group.svg";

const mainComponentObj: { [key in userStepStatusYear]: ReactNode } = {
  noGroup: <NoYearGroupContent />,
  noBooking: <NoBookingContent isRejectedByAllClubs={false} />,
  waitingProposal: <HasProposal />,
  // waitingProposal: <WaitYearBookingProposal />, 예전 화면 안써도될듯
  rejectedAllProposal: <NoBookingContent isRejectedByAllClubs={true} />,
  hasProposal: <HasProposal />,
  // waitingDeposit: <PaymentWating />,
  // waitingDeposit: <HasYearBookingContent />,
  waitingDeposit: <HasYearBookingContent />,
  completeDeposit: <HasYearBookingContent />,
};

export default function YearBooking() {
  const [init] = useRecoilState(recoilStates.init);
  const [group] = useRecoilState(recoilStates.group);
  const [user] = useRecoilState(recoilStates.user);
  const [bookingApplication] = useRecoilState(recoilStates.bookingApplication);
  const clubRelData = bookingApplication?.clubRels?.find((cr) => {
    return [4, 6].includes(cr.year_booking_status_id);
  });
  const roundAsc = [...(clubRelData?.year_booking_round_dates ?? [])].sort((a, b) => {
    return new Date(a.round_date).getTime() - new Date(b.round_date).getTime();
  });
  const nextRound = roundAsc.find((round) => {
    return new Date(Date.now()) < setTime23_59_59(new Date(round.round_date));
  });

  const userStep = useUserStepStatusYear();
  console.log("userStep", userStep);
  const isTeam = nextRound?.is_fixed === 1; // 조 제출여부부
  const is_temp_saved = nextRound?.is_temp_saved === 1; // 조 제출여부부
  const is_paid = nextRound?.is_paid === 1; //결제여부
  const myMemberData = group.members.find((m) => {
    return m.teeshot_user_id && m.teeshot_user_id === user.id;
  });

  // console.log("nextRound", userStep, nextRound, bookingApplication);

  let stepItems: string[] = [];
  let labelItems: string[] = [];
  let title = "";
  if (userStep === "noGroup") {
    title = "티샷 연 단체 예약";
    stepItems = [step1, step2, step3, step4];
    labelItems = ["단체등록", "예약 신청", "조건 협의", "예약 확정"];
  } else if (userStep === "noBooking") {
    title = "희망 골프장을 선택해보세요.";
    stepItems = [step1, step2of, step3of, step4of];
    labelItems = ["단체등록", "예약 신청", "조건 협의", "예약 확정"];
  } else if (userStep === "rejectedAllProposal") {
    stepItems = [step1, step2, step3of, step4of];
    labelItems = ["단체등록", "예약 신청", "조건 협의", "예약 확정"];
  } else if (userStep === "waitingProposal") {
    //골프장 승인대기
    const clubCount = bookingApplication?.clubRels?.length;
    title = `${clubCount}개 골프장에서 조건 검토중입니다.`;
    stepItems = [step1, step2, step3, step4of];
    labelItems = ["단체등록", "예약 신청", "조건 협의", "예약 확정"];
  } else if (userStep === "hasProposal") {
    // 승인된 골프장 수 (조건제시 3)
    const approvedClubCount = bookingApplication?.clubRels?.filter(
      (cr) => cr.year_booking_status_id === 3
    ).length;
    // 검토중인 골프장 수 (검토중 1)
    const reviewingClubCount = bookingApplication?.clubRels?.filter(
      (cr) => cr.year_booking_status_id === 1
    ).length;

    if ((approvedClubCount || 0) > 0) {
      title = `${approvedClubCount || 0}개 골프장에서 신청을 승인했습니다.`;
    } else {
      title = `${reviewingClubCount || 0}개 골프장에서 조건 검토중입니다.`;
    }
    stepItems = [step1, step2, step3, step4of];
    labelItems = ["단체등록", "예약 신청", "조건 협의", "예약 확정"];
  } else if (userStep === "waitingDeposit") {
    stepItems = [step6, step8of, step6of];
    labelItems = ["멤버등록", "조편성", "라운드 확정"];
  } else if (userStep === "completeDeposit") {
    title = "멤버를 등록하고 조를 편성해주세요.";
    if (group.members.length > 0) {
      stepItems = [step6];
    } else {
      stepItems = [step6of];
    }
    if (is_temp_saved) {
      stepItems.push(step8);
    } else {
      stepItems.push(step8of);
    }
    if (isTeam) {
      title = "이용 수수료를 납부해주세요.";
      stepItems.push(step7);
    } else {
      stepItems.push(step7of);
    }
    labelItems = ["멤버등록", "조편성", "라운드 확정"];
  }

  console.log(userStep, group, user, init);

  // const labeltTItle = (() => {
  //   if(userStep === "noGroup"){  return "와 함께하는 티샷 연 단체 예약";

  //   }else if(userStep === "noBooking"){ return "연 단체 예약을 신청해보세요.";
  //   }else if(userStep === "rejectedAllProposal"){ return "연 단체 예약을 신청해보세요.";
  //   }else if(userStep === "waitingProposal"){ return "연 단체 예약을 신청해보세요.";
  //   }else if(userStep === "hasProposal"){ return "연 단체 예약을 신청해보세요.";
  //   }else if(userStep === "waitingDeposit"){ return "연 단체 예약을 신청해보세요.";
  //   }else if(userStep === "completeDeposit"){ return "연 단체 예약을 신청해보세요.";
  // })();

  return (
    <Main className="flex-1 d-flex" $isUserDateFetchDone={init.isInit}>
      {init.isInit ? (
        <>
          {userStep ? (
            <>
              <Stepper
                stepsXpadding="0px"
                className="page-pd-negative-side page-pd-negative-top"
                currentIdx={null}
                title={title}
                steps={stepItems.map((img, index) => ({
                  label: labelItems[index],
                  img: img,
                }))}
              />
              <MainNavBtns
                showingChildNames={userStatusToMenusObj[userStep]}
                childDataObject={childDataObject}
                currentMemberLevel={myMemberData?.booking_group_member_level_id}
                activeMenu={userStep === "completeDeposit" ? "member" : undefined}
              />

              {mainComponentObj[userStep]}
            </>
          ) : null}
        </>
      ) : (
        <></>
      )}
    </Main>
  );
}

const childDataObject: MainNavChildObjectType = {
  roundPayment: {
    icon: <FaCoins size={"22"} />,
    name: "수수료납부",
    size: 4,
    isNav: true,
    navPath: "/year-booking/roundPayment",
    accessAllowedLevels: [1, 2, 4],
  },
  faq: {
    // icon: <TbMessageQuestion size={"22"} />,
    img: faq,
    name: "자주묻는질문",
    size: 4,
    isNav: true,
    navPath: "/year-booking/faq",
    accessAllowedLevels: [],
  },
  group: {
    // icon: <AiFillDatabase size={"22"} />,
    img: groupIcon,
    name: "단체관리",
    isNav: true,
    navPath: "/year-booking/group-manage",
    accessAllowedLevels: [1, 2, 4],
  },
  member: {
    // icon: <IoMdPersonAdd size={"22"} />,
    img: memberIcon,
    name: "멤버등록",
    isNav: true,
    navPath: "/year-booking/group-members/list",
    accessAllowedLevels: [1, 2, 4],
  },
  bookingRegisterResult: {
    // icon: <IoReceiptOutline size={"22"} />,
    img: list,
    name: "신청내역",
    isNav: true,
    navPath: "/year-booking/booking-register/result",
    accessAllowedLevels: [1, 2, 4],
  },
  bookingProposalResult: {
    icon: <FaHandshake size={"22"} />,
    name: "협약내용",
    isNav: true,
    // navPath: "/year-booking?bookingCondition=1",
    navPath: "/year-booking/condition",
    accessAllowedLevels: [1, 2, 4],
  },
  deposit: {
    // icon: <FaCoins size={"22"} />,
    // img: step5,
    name: "보증금 납부",
    isNav: true,
    navPath: "/year-booking/deposit",
    accessAllowedLevels: [1, 2, 4],
  },
};

const userStatusToMenusObj: Partial<{ [key in userStepStatusYear]: NavMenuNames[] }> = {
  noGroup: ["faq"],
  noBooking: ["group", "faq"],
  rejectedAllProposal: ["group", "faq"],
  waitingProposal: ["group", "faq", "bookingRegisterResult"],
  hasProposal: ["group", "faq", "bookingRegisterResult"],
  // waitingDeposit: ["roundPayment", "faq", "group", "member", "bookingProposalResult", "deposit"],
  // waitingDeposit: ["roundPayment", "faq", "group", "member",  "deposit"],
  // completeDeposit: ["roundPayment", "faq", "group", "member", "bookingProposalResult", "deposit"],
  waitingDeposit: ["group", "member", "faq", "bookingRegisterResult", "deposit"],
  completeDeposit: ["group", "member", "faq", "bookingRegisterResult"],
};

const Main = styled.main<{ $isUserDateFetchDone: boolean }>`
  display: flex;
  flex-direction: column;
  ${(p) =>
    !p.$isUserDateFetchDone &&
    css`
      align-items: center;
      justify-content: center;
    `}

  .group-top {
    /* padding: 0px 10px; */
    background-color: ${colors.gray.fourth};
    margin-top: -15px;
    margin-left: -15px;
    margin-right: -15px;

    .img-box,
    img {
      width: 50px;
      height: 50px;
      border-radius: 999px;
    }
    img {
      object-fit: cover;
    }

    .group-img {
    }
  }
`;
